import Actions from "../actions";

const initialState = {
    isLoading: false,
    profileData: {},
    vendorProfileData: {},
    error: false,
};

export const VendorProfileReducer = (state = initialState, action) => {
    switch (action.type) {
        case Actions.PROFILE: {
            return {
                ...state,
                isLoading: true,
            };
        }
        case Actions.PROFILE_SUCCESS: {
            return {
                ...state,
                isLoading: false,
                ProfileData: !action.data?.isVendor ? action.data : state.profileData,
                vendorProfileData: action.data?.isVendor ? action.data : state.vendorProfileData
            };
        }
        case Actions.PROFILE_FAILURE: {
            return {
                ...state,
                isLoading: false,
                error: action.error
            };
        }
        default: {
            return state
        }
    }
};
